import React from 'react';
import './App.css';
import { LanguageProvider, useTranslation } from './language';
import { AppThemeProvider } from './theme';
import { Routes, Route, useLocation, PathRouteProps, useNavigate } from "react-router-dom";
import { WelcomePage, HelpPage, DoctorsPage, QueueScreen, RegisterPage, ReceptionPage } from './pages';
import { BigButton, Logo, Stack } from './components';
import { QueueNumberPage } from './pages/queueNumber';

type DoctorAppRoute = PathRouteProps & {
  showBackButton: boolean;
};

function InnerApp() {
  const [transitionStage, setTransistionStage] = React.useState("fadeIn");
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = React.useState(location);
  const translate = useTranslation();
  const navigate = useNavigate();
  const doctorAppRoutes: Array<DoctorAppRoute> = [
    { path: '/', element: (<WelcomePage key={1} />), showBackButton: false },
    { path: '/doctor', element: (<DoctorsPage key={2} />), showBackButton: true },
    { path: '/help', element: (<HelpPage key={5} />), showBackButton: true },
    { path: '/queue', element: (<QueueScreen key={6} />), showBackButton: false },
    { path: '/reception', element: (<ReceptionPage key={7} />), showBackButton: true },
    { path: '/register', element: (<RegisterPage key={8} />), showBackButton: true },
    { path: '/queueNumber/:queueNumber', element: (<QueueNumberPage key={9} />), showBackButton: true },
  ];

  const showBackButton: (location: any) => boolean = (location) => {
    const appRoute: DoctorAppRoute | undefined = doctorAppRoutes.find(i => i.path === location.pathname);
    return appRoute?.showBackButton ?? false;
  }

  const showLogo: (location: any) => boolean = (_location) => {
    return false;
  }

  React.useEffect(() => {
    if (location !== displayLocation) setTransistionStage("fadeOut");
  }, [location, displayLocation]);

  return (
    <AppThemeProvider>
      <Stack style={{ padding: 50, flex: '0 0 0%', userSelect: 'none' }} horizontal horizontalAlign='center'>
        {showBackButton(location) ? <BigButton style={{ position: 'absolute', left: '3rem' }} text={translate('Common.Back')} onClick={() => { navigate("/") }} /> : null}
        {showLogo(location) ? <Logo style={{ maxWidth: '40%' }} /> : null}
      </Stack>
      <div
        className={`${transitionStage}`}
        onAnimationEnd={() => {
          if (transitionStage === "fadeOut") {
            setTransistionStage("fadeIn");
            setDisplayLocation(location);
          }
        }}
      >
        <Routes location={displayLocation}>
          {doctorAppRoutes.map((route, i) =>
            <Route key={'p-' + (i + 1)} path={route.path} element={route.element} />
          )}
        </Routes>
      </div>
    </AppThemeProvider>
  );
}

function App() {
  return (
    <LanguageProvider>
      <InnerApp />
    </LanguageProvider>
  )
}

export default App;
